export interface deviceResult {
    username: string;
    deviceType: string;
    deviceModel: string;
    deviceOS: string;
    browserName: string;
    browserVersion: string;
    push_notfy_agreed: boolean;
}

interface browserInfo {
    browserName: string;
    browserVersion: string;
}

function getBrowser(): browserInfo {
    // let nVer = navigator.appVersion;
    const nAgt = navigator.userAgent;
    let browserName  = navigator.appName;
    let fullVersion  = ''+parseFloat(navigator.appVersion); 
    let majorVersion = parseInt(navigator.appVersion,10);
    let nameOffset,verOffset,ix;

    // In Opera, the true version is after "OPR" or after "Version"
    if ((verOffset=nAgt.indexOf("OPR"))!=-1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset+4);
        if ((verOffset=nAgt.indexOf("Version"))!=-1) 
        fullVersion = nAgt.substring(verOffset+8);
    }
    // In MS Edge, the true version is after "Edg" in userAgent
    else if ((verOffset=nAgt.indexOf("Edg"))!=-1) {
        browserName = "Microsoft Edge";
        fullVersion = nAgt.substring(verOffset+4);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset+5);
    }
    // In Chrome, the true version is after "Chrome" 
    else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset+7);
    }
    // In Safari, the true version is after "Safari" or after "Version" 
    else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset+7);
        if ((verOffset=nAgt.indexOf("Version"))!=-1) 
        fullVersion = nAgt.substring(verOffset+8);
    }
    // In Firefox, the true version is after "Firefox" 
    else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset+8);
    }
    // In most other browsers, "name/version" is at the end of userAgent 
    else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) < 
            (verOffset=nAgt.lastIndexOf('/')) ) 
    {
        browserName = nAgt.substring(nameOffset,verOffset);
        fullVersion = nAgt.substring(verOffset+1);
        if (browserName.toLowerCase()==browserName.toUpperCase()) {
            browserName = navigator.appName;
        }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix=fullVersion.indexOf(";"))!=-1)
    fullVersion=fullVersion.substring(0,ix);
    if ((ix=fullVersion.indexOf(" "))!=-1)
    fullVersion=fullVersion.substring(0,ix);

    majorVersion = parseInt(''+fullVersion,10);
    if (isNaN(majorVersion)) {
        fullVersion  = ''+parseFloat(navigator.appVersion); 
        majorVersion = parseInt(navigator.appVersion,10);
    }

    return {
        browserName,
        browserVersion: fullVersion
    }

}

function getDevice(user_agent: string, username: string) {
    const index_of_first_bracket = user_agent.indexOf("(");
    const index_of_second_bracket = user_agent.indexOf(")");

    const deviceInfo = user_agent.slice(index_of_first_bracket+1, index_of_second_bracket);

    let OS: string;
    let deviceModel: string;
    let deviceType: string;
    let result: deviceResult;

    const push_notifications_enabled = typeof Notification !== "undefined" && Notification.permission === "granted";

    const browserInfo = getBrowser();

    if(deviceInfo.includes("Android")) {
        let androidDeviceInfo = deviceInfo;
        if(deviceInfo.includes("en-us;")) {
            androidDeviceInfo = androidDeviceInfo.replace("en-us; ","")
        }
        if(deviceInfo.includes("U;")) {
            androidDeviceInfo = androidDeviceInfo.replace("U; ", "")
        }
        const detectedOS  = androidDeviceInfo.split("; ")[1]
        deviceModel = androidDeviceInfo.split("; ")[2];
        OS = detectedOS;
        deviceType = "Mobile";
        result = {
            username,
            browserName: browserInfo.browserName,
            browserVersion: browserInfo.browserVersion,
            deviceType,
            deviceModel,
            deviceOS: OS,
            push_notfy_agreed: push_notifications_enabled
        };
    }
    else {
        if(deviceInfo.split("; ")[0] === "Macintosh") {
            deviceModel = "Mac";
            const detectedOS = deviceInfo.split("; ")[1].replace("Intel Mac ", "").replace("_", ".").replace("_", ".");
            OS = detectedOS;
            deviceType = "Desktop/Laptop";
            result = {
                username,
                browserName: browserInfo.browserName,
                browserVersion: browserInfo.browserVersion,
                deviceType,
                deviceModel,
                deviceOS: OS,
                push_notfy_agreed: push_notifications_enabled
            };
        }
        if(deviceInfo.split("; ")[0].includes("Windows")) {
            const windowsInfo = deviceInfo.split("; ")[0].split(" ");
            deviceModel = windowsInfo[0];
            const windowsVersion = windowsInfo[windowsInfo.length-1];
            if(windowsVersion === "10.0") {
                OS = "10/11"
            }
            if(windowsVersion === "6.3") {
                OS = "8.1"
            }
            if(windowsVersion === "6.2") {
                OS = "8"
            }
            if(windowsVersion === "6.1") {
                OS = "7"
            }
            if(windowsVersion === "6.0") {
                OS = "Vista"
            }
            if(windowsVersion === "5.1") {
                OS = "XP"
            }
            if(windowsVersion === "5.0") {
                OS = "2000"
            }
            OS = `Windows ${OS!}`;
            deviceType = "Desktop/Laptop";
            result = {
                username,
                browserName: browserInfo.browserName,
                browserVersion: browserInfo.browserVersion,
                deviceType,
                deviceModel,
                deviceOS: OS,
                push_notfy_agreed: push_notifications_enabled
            };
        }
        else {
            if(deviceInfo.includes("Mac OS") && !deviceInfo.split("; ")[0].includes("Macintosh")) {
                deviceModel = deviceInfo.split("; ")[0];
                const detectedOS = deviceInfo.split("; ")[1].split(" ")[deviceInfo.split("; ")[1].split(" ").indexOf("OS")+1].replace("_", ".").replace("_", ".")
                OS = `iOS ${detectedOS}`;
                deviceType = "Mobile";
                result = {
                    username,
                    browserName: browserInfo.browserName,
                    browserVersion: browserInfo.browserVersion,
                    deviceType,
                    deviceModel,
                    deviceOS: OS,
                    push_notfy_agreed: push_notifications_enabled
                };
            }
        }
    }
    if(result!) {
        return result;
    }
}

export default getDevice;